import { Youtube } from 'components/video'

export const POSTS = [
  {
    id: 11,
    slug: 'serie-selecao-especial-fazendinha-em-casa-produtos-autenticos',
    categories: [{ slug: 'fazendinha-em-casa', name: 'Fazendinha em Casa' }],
    createdAt: '11 de dezembro de 2024',
    title: 'Série Seleção Especial Fazendinha em Casa: produtos autênticos e cheios de afeto',
    description:
      'Descubra a Série Seleção Especial da Fazendinha em Casa. Feita par você que gosta de sabores autênticos e únicos. Além de serem sustentáveis do momento que foram criados até chegarem a você! Quer saber mais? Clique aqui que te levamos para uma experiência única.',
    image: {
      url: '/assets/images/blog/Serie-selecao-especial-Fazendinha-em-Casa-Produtos-autenticos-e-cheios-de-afeto.jpg',
    },
    content: (
      <article>
        <p>
          Era uma vez um sonho que nasceu do campo, guiado pelo amor, pela terra e pelo respeito aos que dela vivem. Desde o início, a <strong><em>Fazendinha em Casa</em></strong> tem se dedicado a conectar pessoas com sabores que falam ao coração, traduzindo o trabalho de produtores locais em experiências autênticas e cheias de afeto.
        </p>

        <p>
          Agora, pela primeira vez, damos um passo ainda mais especial: apresentamos a Série Seleção Especial. Uma curadoria única, feita com cuidado e carinho, para trazer até você o melhor do campo em sua forma mais pura. Essa seleção é o resultado de uma jornada inspiradora, em busca de produtos que não apenas encantassem o paladar, mas também carregassem a essência da história da Fazendinha em Casa. Os produtos escolhidos para estrear essa série têm alma, tradição e sabor. São eles:
        </p>

        <img
          src="/assets/images/blog/Selecao-especial-Fazendinha-em-Casa-produtos-doce-de-leite-queijo-baby-cafe-especial-imagem-aquarelada-de-fazenda-vacas-passarinho-café.jpg"
          alt="Selecao-especial-Fazendinha-em-Casa-produtos-doce-de-leite-queijo-baby-cafe-especial-imagem-aquarelada-de-fazenda-vacas-passarinho-café"
        />

        <p>&nbsp;</p>

        <h2>Queijo Minas Meia Cura Baby</h2>
        <p><strong>Origem:</strong> CAMPO DAS VERTENTES | MINAS GERAIS</p>

        <p>
          Com sua cor dourada, textura macia e sabor marcante, é a perfeita representação da autenticidade mineira. Um queijo de sabor autoral único. O laticínio fica dentro da própria fazenda, que produz a alimentação do gado, que por sua vez gera adubo para a própria plantação de milho. Um manejo sustentável de todo o ecossistema.
        </p>

        <p>&nbsp;</p>

        <h2>Café Especial Mantiqueira</h2>
        <p><strong>Origem:</strong> SERRA DA MANTIQUEIRA | SUL DE MINAS GERAIS</p>

        <p>
          Com seus grãos 100% arábica, oferece um aroma e um gosto que transformam qualquer momento em um ritual de prazer. Personalidade sensorial marcante, saboroso e aromático. Notas de baunilha e chocolate já presentes desde o aroma. Um café muito doce com leve sabor de frutas amarelas. Acidez cítrica média, corpo aveludado e final prolongado com notas de chocolate ao leite.
        </p>

        <p>
          Na Fazenda Itaoca, o homem, o solo, a água, o café, a fauna e a flora interagem harmoniosamente com o meio ambiente. Um paraíso <strong><em>sustentável</em></strong>, cercado de Mata Atlântica, na Serra da Mantiqueira, no Sul de Minas. Tudo cuidado pela família com muito amor pela natureza. Isso se traduz em sabores e aromas surpreendentes e únicos desta seleção.
        </p>

        <p><em>84,4 pontos SCA | Variedade Catuaí Vermelho</em></p>
        <p><em>Tipo 2 - grãos selecionados eletronicamente</em></p>
        <p><em>Processo de secagem natural | Peneira 17-18</em></p>
        <p><em>Cultivo a uma altitude de 1100m</em></p>

        <p>&nbsp;</p>

        <h2>Doce de Leite Pastoso</h2>
        <p><strong>Origem:</strong> CAMBUÍ | SUL DE MINAS GERAIS</p>

        <p>
          Com sua cremosidade e doçura na medida certa, é uma verdadeira viagem às lembranças mais doces. É o clássico doce de leite pastoso. Puro, sem adição de amido. Toda cremosidade e tradição mineira em um só pote. Produção familiar!
        </p>

        <p>
          Cada detalhe foi pensado para que a experiência fosse completa, desde os sabores até os rótulos. Inspirados na leveza da natureza, os elementos em aquarela, como os passarinhos, simbolizam liberdade e conexão. São como mensageiros do campo, trazendo consigo histórias de produtores que dedicam suas vidas a transformar o simples em especial.
        </p>

        <p>
          A <strong>Série Seleção Especial</strong> não é apenas uma coleção de produtos. É um gesto. Uma celebração ao que é local, sustentável e feito com amor. Um convite para que você faça parte dessa jornada e leve para a sua mesa o que há de mais autêntico.
        </p>

        <p>&nbsp;</p>

        <h2>Seleção Fazendinha em Casa</h2>

        <p>
          Essa é a primeira seleção especial da nossa história. Um marco que nós da Fazendinha em Casa queremos dividir com você, para que cada momento seja ainda mais especial. Seja para degustar, para presentear ou para transformar um dia comum em uma memória inesquecível, a Série <strong>Seleção Especial</strong> está aqui para levar até você o sabor verdadeiro do campo.
        </p>

        <p>
          Fazendinha em Casa. Sabores que conectam, histórias que encantam. Clique <a target='_blank' href="https://www.fazendinha.me/produtos/selecao-especial-fazendinha" title="Série Seleção Especial">aqui</a> e conheça.
        </p>

      </article>
    ),
  },
  {
    id: 10,
    slug: 'produtores-locais-o-ciclo-virtuoso-que-seu-negocio-pode-gerar',
    categories: [{ slug: 'empresas-locais', name: 'Empresas Locais' }],
    createdAt: '11 de dezembro de 2024',
    title: 'Produtores locais: o ciclo virtuoso que seu negócio pode gerar! Quer saber mais?',
    description:
      'Descubra como o consumo consciente e a produção local impulsionam a economia regional, gerando benefícios para a comunidade e o meio ambiente. Explore o poder da sua escolha!',
    image: {
      url: '/assets/images/blog/Produtores-locais-o-ciclo-virtuoso-que-seu-negocio-pode-gerar-quer-saber-mais.jpg',
    },
    content: (
      <article>
        <p>
          <strong>Produção local</strong> é sinônimo de frescor, qualidade e sabor de verdade. Mas, além disso, optar por produtos da sua região é uma maneira prática que seu negócio possui de fortalecer a economia local e contribuir para o desenvolvimento sustentável.
        </p>

        <p>
          Quando você compra de pequenos produtores, você incentiva o cultivo consciente e o trabalho justo. <strong>Dessa forma, mais pessoas ganham</strong>: desde o agricultor até o seu negócio, criando um círculo virtuoso!
        </p>

        <p>
          Além disso, o dinheiro circula na comunidade, gerando mais empregos e oportunidades. E claro, o impacto positivo vai muito além do prato. É um ciclo de benefícios que transforma a forma como lidamos com o alimento, preservando culturas tradicionais e lidando com os hábitos de compra das novas gerações.
        </p>

        <p>&nbsp;</p>

        <h2>
          O Papel da Produção Local no meu negócio
        </h2>

        <p>
          Apostar em <strong>produtos locais</strong> é investir diretamente na economia regional e na riqueza cultural de cada lugar. Ao escolher o que é produzido perto de você, valoriza-se o saber de quem mantém viva a tradição e, ao mesmo tempo, incentiva-se a inovação sustentável.
        </p>

        <p>
          Além disso, o consumo local <strong>impulsiona</strong> mais <strong>negócios</strong> e cria uma cadeia de benefícios que gera empregos, fortalece laços comunitários e garante um futuro mais justo e consciente.
        </p>

        <h3>
          <p>
          <strong>Como comprar de um produtor local fortalece a economia?</strong>
          </p>
        </h3>

        <p>
          O produtor local tem um papel fundamental no fortalecimento da <strong>economia regional</strong>. Ao comprar de pequenos produtores, o seu negócio vai ajudar a gerar emprego e manter a renda circulando na própria comunidade, criando um ciclo virtuoso de crescimento econômico.
        </p>

        <p>
          Esse <strong>consumo consciente</strong> permite que o dinheiro investido fique por perto, beneficiando a agricultura familiar, o pequeno produtor e todos os envolvidos na cadeia produtiva. Inclusive o seu cliente, que é quem vai consumir produtos de qualidade!
        </p>

        <p>
          Além disso, com o incentivo ao comércio de proximidade, as empresas locais ganham força e conseguem se desenvolver de forma sustentável. Por isso, ao dar preferência a quem está ao seu redor, você contribui para um mercado mais equilibrado e solidário, onde todos têm a chance de crescer juntos.
        </p>

        <p>&nbsp;</p>

        <h2>O Poder do Consumo Consciente: A geração Z e seus hábitos de compra</h2>

        <p>
          O <strong>consumo consciente</strong> já é algo que vem ocorrendo e a geração Z demonstra que possui preocupação com o que consome e o impacto de cada produto que consome. Cada decisão de compra impacta diretamente o meio ambiente, a sociedade e também a economia regional. Então, quando o seu negócio compra de um pequeno produtor, você está dialogando com as novas gerações e impactando de forma positiva o meio ambiente.
        </p>

        <p>Ao optar por produtos e produtores locais, você:</p>

        <ul>
          <li>
            <p>
              <strong>1. Incentiva práticas agrícolas</strong> que respeitam a natureza, reduzindo o uso de agrotóxicos e produtos químicos, além de promover a biodiversidade.
            </p>
          </li>
          <li>
            <p>
              <strong>2. Fortalece a economia regional</strong>, mantendo o dinheiro circulando na comunidade e criando oportunidades de emprego.
            </p>
          </li>
          <li>
            <p>
              <strong>3. Apoia iniciativas que buscam inovação</strong> e respeito ao meio ambiente, dando espaço para negócios comprometidos com um futuro melhor.
            </p>
          </li>
        </ul>

        <p>
          Assim, optando por produtos de agricultura familiar, o seu negócio pode gerar grandes mudanças para todos.
        </p>

        <p>&nbsp;</p>

        <h3>
          <p>
            <strong>Unindo Tradição e Inovação na Mesa</strong>
          </p>
        </h3>

        <p>
          Os produtores pequenos de <strong>produtos artesanais</strong> trazem para a mesa o melhor da tradição e da inovação. Com técnicas passadas de geração em geração, a produção local combina o saber antigo com novas ideias, criando sabores autênticos e únicos.
        </p>

        <p>
          Ao escolher esses produtos, você valoriza a cultura e a riqueza de cada região, incentivando pequenos produtores a continuarem compartilhando suas raízes, sendo seu restaurante, supermercado ou empório, um espaço para tal.
        </p>

        <p>
          Além disso, essa mistura de <strong>tradição com um toque moderno</strong> não só garante um sabor diferenciado, mas também promove a sustentabilidade. Assim, cada escolha de compra se torna um ato de valorização da história e de apoio a um futuro mais responsável e saboroso.
        </p>

        <p>&nbsp;</p>

        <h3>
          <p>
            <strong>Vantagens Econômicas para o seu negócio</strong>
          </p>
        </h3>

        <p>
          Optar por produtos locais traz diversas <strong>vantagens econômicas</strong> que impactam diretamente o bolso e a economia regional. Ao escolher produtos da sua própria região, você:
        </p>

        <ol>
          <li>
            <p>
              <strong>1. Reduz custos de logística</strong>, já que o transporte é mais curto e menos oneroso, o que pode se refletir em preços mais acessíveis para o consumidor final.
            </p>
          </li>
          <li>
            <p>
              <strong>2. Incentiva o crescimento da economia estadual</strong>, mantendo o dinheiro circulando dentro do estado e apoiando os negócios locais.
            </p>
          </li>
          <li>
            <p>
              <strong>3. Estimula um mercado mais sustentável</strong>, com menor pegada de carbono devido à proximidade.
            </p>
          </li>
        </ol>

        <p>
          Além disso, o consumo de produtos locais cria uma rede de apoio entre pequenos produtores e negócios locais, gerando benefícios que se espalham por toda a comunidade e promovem um desenvolvimento mais equilibrado.
        </p>

        <p>&nbsp;</p>

        <h3>
          <p>
            <strong>Produtos Locais: Opção Acessível e Sustentável</strong>
          </p>
        </h3>

        <p>
          Optar por produtos locais é uma escolha inteligente que traz benefícios tanto para o bolso e saúde financeira da sua empresa, quanto para o meio ambiente. Ao apoiar a produção local, você incentiva práticas mais sustentáveis e fortalece a economia regional.
        </p>

        <p>&nbsp;</p>

        <h3>
          <p>
            <strong>Veja alguns dos principais benefícios:</strong>
          </p>
        </h3>

          <h4>
            <p>Preços Justos</p>
          </h4>

          <p>
            Resultando em <strong>custos mais baixos</strong> e preços mais justos, além de oferecer maior frescor e qualidade, sem abrir mão do valor que o mercado exige.
          </p>

          <h4>
            <p>Práticas Sustentáveis</p>
          </h4>

          <p>
            O transporte reduzido diminui a pegada de carbono, contribuindo para um consumo mais consciente e um <strong>impacto ambiental menor</strong>, promovendo assim um estilo de vida mais sustentável e ecológico para todos.
          </p>

          <p>&nbsp;</p>

        <h2>Conclusão</h2>

        <p>
          Escolher <strong>produtos locais</strong> é uma decisão inteligente que beneficia o seu negócio e a economia regional.  Além de apoiar o desenvolvimento sustentável e a preservação de tradições culturais valiosas, impacta diretamente no consumo das novas gerações que cada vez mais se interessam na experiência do que consomem.
        </p>

        <p>
          Ao optar pela produção local, você contribui para um ciclo de crescimento que fortalece a comunidade e respeita o meio ambiente, e um ciclo virtuoso que beneficia seu negócio e clientes!
        </p>

        <p>
          Ficou interessado em conhecer mais sobre produtos locais? Chama a gente no <a target='_blank' href="https://api.whatsapp.com/send?phone=5531982404927&text=Ol%C3%A1%2C%20quero%20saber%20mais%20sobre%20produtos%20locais!" title="Fale conosco">whatsapp</a> que te apresentamos a diversa possibilidade com nosso mix de produtos.
        </p>

      </article>
    ),
  },
  {
    id: 9,
    slug: 'uma-explosao-de-sabores-a-magia-dos-queijos-artesanais',
    categories: [{ slug: 'curiosidades´', name: 'curiosidades' }],
    createdAt: '11 de dezembro de 2024',
    title: 'Uma Explosão de Sabores: A Magia dos Queijos Artesanais',
    description:
      'Uma explosão de sabores no seu paladar! Desvende os segredos dos queijos artesanais e descubra o seu favorito.',
    image: {
      url: '/assets/images/blog/Uma-Explosão -de -Sabores-A-Magia-dos-Queijos-Artesanais.jpg',
    },
    content: (
      <article>
        <p>
          O queijo é muito mais do que um simples acompanhamento para pães e vinhos. Por trás de cada fatia há uma história rica em tradições, culturas e práticas locais que transformam esse alimento em um dos mais diversos e fascinantes do mundo. De sua origem até a forma como é produzido em diferentes regiões, o queijo reflete a relação íntima entre o ambiente onde é produzido, o clima, e a cultura de cada local.
        </p>

        <p>
          Neste artigo, vamos explorar a <strong>divisão territorial dos queijos</strong>, revelando como a produção local influencia diretamente suas características, sabores e texturas. Além disso, você conhecerá algumas curiosidades fascinantes que envolvem esse alimento milenar, que agrada paladares ao redor do mundo.
        </p>

        <p>
          O queijo é, sem dúvida, um alimento com uma história rica e uma grande diversidade de sabores. Ao explorar a <strong>divisão territorial dos queijos</strong> e conhecer as curiosidades por trás de sua produção, podemos apreciar ainda mais esse produto, que vai além do simples ato de comer. Ele é o resultado de uma jornada que envolve cultura, natureza e a paixão dos produtores locais.
        </p>

        <p>&nbsp;</p>

        <h2>
          A História e a Produção Local dos Queijos
        </h2>

        <p>
          A produção de queijo data de milhares de anos, com registros de sua existência desde a Antiguidade. Naquela época, o queijo era produzido como uma forma de preservar o leite, transformando-o em um alimento mais durável e facilmente armazenável.
        </p>

        <p>
          Com o tempo, as <strong>práticas locais de produção</strong> se desenvolveram em várias partes do mundo, levando à criação de diferentes tipos de queijo, cada um com suas características únicas.
        </p>

        <p>
          Uma das principais razões para a diversidade de queijos ao redor do mundo é o <strong>território (Terrior)</strong>. Esse termo, terrior, muito utilizado na produção de vinhos, também se aplica à produção de queijo. O terroir inclui fatores como o clima, o tipo de solo, a vegetação e até mesmo a raça dos animais que fornecem o leite. Esses elementos combinados influenciam diretamente o sabor, a textura e o aroma dos queijos produzidos em cada região.
        </p>

        <h3>
          <p>
          <strong>A Produção Local e o Valor dos Queijos Regionais</strong>
          </p>
        </h3>

        <p>
          Queijos produzidos localmente, como o <strong>Brie</strong> na França, o <strong>Parmesão</strong> na Itália ou o <strong>Queijo da Serra da Estrela</strong> em Portugal, são altamente valorizados por sua <strong>autenticidade</strong> e conexão com o ambiente onde são feitos. Esses queijos carregam consigo não apenas o sabor, mas também a história e a cultura da região.
        </p>

        <p>
          A <strong>produção local</strong> de queijos também contribui para a sustentabilidade, já que promove práticas agrícolas responsáveis e minimiza o impacto ambiental, evitando o transporte de longa distância. Consumir queijos de produção local é uma maneira de valorizar a economia regional e apoiar pequenos produtores, que muitas vezes seguem métodos tradicionais de fabricação.
        </p>

        <p>&nbsp;</p>

        <h2>A Divisão Territorial dos Queijos: Um Mapa de Sabores</h2>

        <p>
          Cada região produtora de queijo tem suas próprias técnicas, ingredientes e condições que influenciam o resultado final. Por isso, ao longo do tempo, criou-se uma <strong>divisão territorial dos queijos</strong> que agrupa os diferentes tipos de acordo com sua origem. Vamos explorar algumas dessas divisões e o que as torna tão especiais.
        </p>

        <p>&nbsp;</p>

        <h3>
          <p>
          <strong>1. França: O Berço dos Queijos Tradicionais</strong>
          </p>
        </h3>

        <p>
          A França é conhecida mundialmente por sua rica produção de queijos, com mais de <strong>400 variedades</strong>. Entre os mais famosos estão o <strong>Camembert</strong>, o <strong>Brie</strong> e o <strong>Roquefort</strong> (este é feito geralmente com leite de cabra). Esses queijos são protegidos por denominações de origem, o que significa que só podem ser produzidos em certas regiões, seguindo métodos específicos.
        </p>

        <p>
          A diversidade climática da França é um fator importante para a variedade de queijos. No norte, o clima mais úmido favorece queijos como o Brie e o Camembert, enquanto as regiões montanhosas, como os Pirineus, produzem queijos mais secos e duros, como o Tomme de Savoie.
        </p>

        <p>&nbsp;</p>

        <h3>
          <p>
          <strong>2. Itália: Queijos com Tradição Milenar</strong>
          </p>
        </h3>

        <p>
          A Itália é outro país famoso pela sua produção de queijos. O <strong>Parmesão</strong> (Parmigiano-Reggiano), produzido na região da Emilia-Romagna, é um dos queijos mais renomados do mundo. Sua produção segue normas rigorosas, e o leite utilizado provém de vacas que são alimentadas com forragens locais, o que confere ao queijo seu sabor único.
        </p>

        <p>
          Outro exemplo de queijo tradicional italiano é o <strong>Pecorino</strong>, feito a partir de leite de ovelha e produzido principalmente nas regiões da Sardenha, Toscana e Sicília.O Pecorino é um queijo de Denominação de Origem Protegida (DOP), garantindo que ele seja produzido com técnicas artesanais e ingredientes locais.
        </p>

        <p>&nbsp;</p>

        <h3>
          <p>
          <strong>3. Portugal: O Queijo da Serra da Estrela</strong>
          </p>
        </h3>

        <p>
          Em Portugal, o <strong>Queijo da Serra da Estrela</strong> é considerado o rei dos queijos. Feito com leite de ovelha bordaleira, esse queijo é produzido na região montanhosa da Serra da Estrela e segue uma receita tradicional que remonta a séculos. Sua produção ocorre de maneira artesanal, respeitando o tempo necessário para que o queijo atinja sua maturação ideal.
        </p>

        <p>
          O clima frio e a vegetação da Serra da Estrela contribuem diretamente para o sabor desse queijo, que é cremoso e de sabor forte. Consumir esse queijo é como experimentar um pedaço da cultura portuguesa, um reflexo da relação entre a natureza e o produtor.
        </p>

        <p>&nbsp;</p>

        <h2>Curiosidades Sobre o Mundo dos Queijos</h2>

        <p>
          Além das diferenças regionais e da riqueza de sabores, o mundo dos queijos é cheio de curiosidades que tornam esse alimento ainda mais interessante.
        </p>

        <p>&nbsp;</p>

        <h3>
          <p>
          <strong>1. O Queijo Mais Antigo do Mundo</strong>
          </p>
        </h3>

        <p>
          O queijo mais antigo já encontrado tem mais de <strong>3.200 anos</strong> e foi descoberto na tumba de Ptahmes, no Egito. Acredita-se que ele era feito com uma mistura de leite de vaca e ovelha.
        </p>

        <p>&nbsp;</p>

        <h3>
          <p>
          <strong>2. O Queijo Mais Caro do Mundo</strong>
          </p>
        </h3>

        <p>
          O queijo mais caro do mundo é o <strong>Pule</strong>, produzido na Sérvia com leite de burra. O processo de produção é extremamente trabalhoso, o que o torna raríssimo e muito valorizado.
        </p>

        <p>&nbsp;</p>

        <h3>
          <p>
          <strong>3. Os Benefícios do Queijo Artesanal e Orgânico</strong>
          </p>
        </h3>

        <img
          src="/assets/images/blog/variedades-de-queijo-por-divisao-geografica.jpg"
          alt="variedades-de-queijo-por-divisao-geografica"
        />

        <p>&nbsp;</p>

        <p>
          Os queijos orgânicos são produzidos sem o uso de aditivos químicos e sem hormônios de crescimento nos animais, o que os torna uma escolha mais saudável e sustentável. Esses queijos preservam melhor o sabor natural do leite e são produzidos com respeito ao meio ambiente.
        </p>

        <p>
          <strong>Alimentos artesanais</strong>, como os queijos, estão ganhando cada vez mais espaço entre os consumidores conscientes, que buscam qualidade e sustentabilidade em suas escolhas alimentares. A produção local, também promove uma cadeia mais curta entre produtor e consumidor, garantindo maior frescor e menor impacto ambiental.
        </p>

        <p>&nbsp;</p>

        <h2>A Importância de Valorizar a Produção Local e Artesanal de Queijos</h2>

        <p>
          A escolha por queijos de <strong>produção local</strong> e <strong>artesanais</strong> vai além do paladar. Ela está diretamente conectada a um estilo de vida mais consciente e sustentável.
        </p>

        <p>
          <em>
            <strong>
              Consumir produtos que respeitam o tempo da natureza e a cultura local é uma forma de preservar tradições e apoiar práticas que têm impacto positivo no meio ambiente.
            </strong>
          </em>
        </p>

        <p>
          Optar por queijos de <strong>pequenos produtores locais</strong> também garante a autenticidade e a qualidade dos alimentos que você consome. Esses produtores seguem métodos tradicionais de fabricação, o que preserva o sabor original do queijo e cria uma conexão mais próxima entre você e a origem do alimento.
        </p>

        <p>
          Com consumidores cada vez mais conscientes, ofertar produtos locais e artesanais faz toda a diferença!
        </p>

        <p>
          Aqui na Fazendinha você encontra queijos variados para ofertar aos seus clientes, isso mesmo, quer ter uma variedade de queijos artesanais em seu empório, mercado ou restaurante? <a target='_blank' href="https://api.whatsapp.com/send?phone=5531982404927&text=Ol%C3%A1%2C%20quero%20saber%20mais%20sobre%20queijos%20artesanais!" title="Fale conosco">Clique aqui e fale conosco</a>
        </p>

      </article>
    ),
  },
  {
    id: 8,
    slug: 'fazendinha-em-casa-concorre-premio-startup-revelacao-startup-award-2024',
    categories: [{ slug: 'startup-awards-2024´', name: 'Startup Awards 2024' }],
    createdAt: '04 de novembro de 2024',
    title: 'Como a Fazendinha em casa está impactando o mercado e concorrendo ao prêmio de Startup Revelação no Startup Award 2024?',
    description:
      'Descubra como a Fazendinha em Casa está impactando o mercado no Brasil ao conectar pequenos produtores e consumidores. Concorrendo como Startup Revelação de 2024 no Startup Awards, a empresa promove sustentabilidade, crescimento local e inovação no ecossistema de startups.',
    image: {
      url: '/assets/images/blog/Como-a-Fazendinha-em-Casa-esta-impactando-o-mercado-e-concorrendo_ao prêmio de Startup Revelação no Startup Award 2024_.jpg',
    },
    content: (
      <article>
        <p>
          A Fazendinha está concorrendo como <strong>startup revelação 2024</strong> no Startup Awards. Esta é a
          maior premiação do ecossistema de inovação e empreendedorismo no Brasil, reconhecendo
          empresas e profissionais que têm impactado o cenário nacional de tecnologia e negócios.
          Organizado pela Associação Brasileira de Startups (Abstartups), o evento se consolidou como
          um marco de reconhecimento para startups que, além de inovadoras, desempenham um papel
          importante no desenvolvimento do país.
        </p>

        <p>
          A Fazendinha em Casa é uma empresa que traz o conceito “Farm to Table” para o cotidiano,
          resgatando a qualidade e o prazer de uma alimentação cheia de sabores reais. Imagine ter
          alimentos frescos e saudáveis diretamente do campo para a sua mesa, com a certeza de estar
          apoiando pequenos produtores e praticando o consumo consciente? Essa é a essência da
          startup, que concorre na categoria <strong>“Startup Revelação de 2024”</strong>.
        </p>

        <p>
          O Startup Awards celebra a força do ecossistema brasileiro e destaca iniciativas que estão
          moldando o futuro do mercado de tecnologia e negócios no país. A cada edição, o evento
          reforça a importância de reconhecer quem está à frente das mudanças, promovendo um
          ambiente favorável para o crescimento e a inovação no Brasil.
        </p>

        <p>&nbsp;</p>

        <h2>
          A Fazendinha em Casa: Unindo Produtores Locais e
          Consumidores em uma Experiência “Farm to Table”
        </h2>

        <p>
          A Fazendinha em Casa acredita na valorização dos pequenos produtores e no impacto positivo
          que o consumo de produtos locais pode ter na economia local, regional, e provavelmente
          nacional. O diferencial da Fazendinha é sua habilidade em unir a tradição do ambiente do
          campo com a inovação tecnológica, facilitando a compra online de produtos frescos e
          autênticos. Em nossa plataforma, produtores de agricultura familiar encontram espaço para
          vender diretamente aos consumidores, profissionais da gastronomia e comércios em geral, por
          meio de ferramentas de comercialização e logística, online ou offline. Desta forma os clientes
          têm acesso rápido e prático a uma variedade de alimentos, direto da fazenda para as mesas
          das residências e do setor gastronômico.
        </p>

        <p>
          A Fazendinha em Casa proporciona o acesso a uma variedade de produtos agroecológicos,
          artesanais e facilita o mercado para pequenos produtores. &quot;Aumentamos em cinco vezes o
          volume de vendas entre 2022 e 2023, e nossa projeção é em até 2025 crescermos dez vezes
          mais&quot;, afirma Claudia Ligório Co-Fundadora da Agrifoodtech.
        </p>

        <p>&nbsp;</p>

        <h2>Reconhecimento</h2>

        <p>
          É uma grande honra ser nomeado para uma premiação de tamanha relevância e grandiosidade
          como o <strong>Startup Awards 2024</strong>. A Fazendinha em Casa cresce exponencialmente ano após
          ano, demonstrando como a valorização de produtos agroecológicos e produtores locais pode
          fortalecer a economia e como uma solução tecnológica pode impulsionar negócios regionais.
          Contamos com <strong>o seu voto</strong> para atingirmos o <a target='_blank' href="https://www.startupawards.com.br/" title="Startup Awards 2024">top 3 dentre as startups revelações!</a>
        </p>

      </article>
    ),
  },
  {
    id: 7,
    slug: 'diferenças-galinhas-livres-gaiolas-galinhas-caipiras-melhor-ovo',
    categories: [{ slug: 'consumo-consciente', name: 'Consumo Consciente' }],
    createdAt: '04 de novembro de 2024',
    title: 'Ovos de Galinhas Livres de Gaiolas X Galinha Caipira: Qual é Realmente Melhor? Descubra as Diferenças!',
    description:
      'Você acha que galinhas livres de gaiolas e galinhas caipiras são a mesma coisa? A verdade é que há diferenças surpreendentes entre esses tipos de criação - e isso impacta o sabor, a qualidade nutricional e o bem-estar animal! Antes de escolher seus ovos, veja o que você precisa saber sobre esses dois métodos. Qual será o melhor para você?',
    image: {
      url: '/assets/images/blog/Ovos-de-galinhas-livres-de-gaiolas-X-galinha-Caipira-Qual-é-Realmente-melhor-descubra-as-diferenças.jpg',
    },
    content: (
      <article>
        <p>
          O consumo consciente tem sido cada vez mais buscado por pessoas que desejam alinhar
          suas escolhas alimentares com valores de bem-estar animal, sustentabilidade e qualidade
          de vida. Esse movimento se reflete, por exemplo, no aumento da demanda por ovos de
          galinhas criadas livres de gaiolas, e galinhas caipiras, que oferecem uma vida digna para as
          aves e melhor qualidade nutricional dos ovos. Neste artigo, exploramos os benefícios de
          consumir ovos de galinhas livres de gaiolas e galinhas caipiras, além da atuação da
          Fazendinha em Casa, que facilita o seu acesso a esses produtos.
        </p>

        <p>&nbsp;</p>

        <h2>O Que São Ovos de Galinhas Criadas Livres e Galinhas Caipiras?</h2>

        <p>
          Galinhas criadas livres de gaiolas vivem em ambientes com mais espaço e podem
          expressar comportamentos naturais como ciscar, empoleirar-se e andar. Elas não ficam
          confinadas em pequenas gaiolas, como na produção industrial, o que reduz o estresse e
          melhora sua qualidade de vida.
        </p>

        <p>
          Já a galinha caipira vai além: criada de maneira tradicional em áreas rurais, ela é totalmente
          solta no campo, o que permite uma alimentação variada, incluindo milho, insetos e outros
          alimentos encontrados ao ar livre. Enquanto as galinhas livres de gaiolas podem ter uma
          dieta baseada em rações de boa qualidade, as caipiras, tem sua criação baseada em uma
          alimentação natural.
        </p>

        <p>&nbsp;</p>

        <h2>Benefícios dos Ovos de Galinhas Criadas Livres e Caipiras</h2>

        <p>
          <strong>Maior Valor Nutricional:</strong> Estudos indicam que tanto os ovos de galinhas criadas livres
          quanto os de galinhas caipiras possuem mais nutrientes do que os ovos de aves confinadas
          em gaiolas. No entanto, o perfil de nutrientes pode variar: enquanto as galinhas livres de

          gaiolas tendem a oferecer ovos com mais ômega-3, vitaminas E e D, a alimentação natural
          das galinhas caipiras pode enriquecer ainda mais os ovos com esses nutrientes, além de
          impactar a cor e a qualidade das gemas e claras.
        </p>

        <p>
          <strong>Sabor Diferenciado:</strong> Tanto os ovos de galinhas criadas livres quanto os de caipiras são
          considerados mais saborosos em comparação com ovos de galinhas de granja. Contudo, a
          dieta diversificada e o estilo de vida da galinha caipira conferem um sabor ainda mais
          intenso.
        </p>

        <p>
          <strong>Bem-Estar Animal:</strong> Ao optar por ovos de galinhas criadas livres de gaiolas, você apoia
          práticas que promovem a dignidade animal, o que também ocorre com a criação de
          galinhas caipiras.
        </p>

        <p>
          A diferença está no <strong>tipo de liberdade</strong>: as galinhas criadas livres podem se movimentar em
          áreas maiores, mas geralmente em ambientes controlados. Já as caipiras vivem soltas nos
          campos, tendo acesso a um espaço ainda mais amplo e natural.
        </p>

        <p>
          <strong>Menor Uso de Antibióticos:</strong> As galinhas livres de gaiola tendem a precisar menos de
          antibióticos em comparação com as aves de granja, devido à menor densidade de animais
          e melhores condições de saúde. Já as Galinhas Caipiras são criadas sem o uso de
          antibióticos, refletindo-se em ovos mais naturais.
        </p>

        <img
          src="/assets/images/blog/Ovos-frescos-de-galinhas-livres-de -gaiolas -e-caipiras-em-um-ambiente-sustentável.jpg"
          alt="Ovos frescos de galinhas livres de gaiolas e caipiras em um ambiente sustentável"
        />

        <p>&nbsp;</p>

        <h2>O Impacto Ambiental de Criar Galinhas Fora de Gaiolas e Galinhas Caipiras</h2>

        <p>
          Ambos os tipos de criação – livre de gaiolas e caipira – são mais sustentáveis que o modelo
          industrial, mas com abordagens um pouco diferentes. A criação de galinhas caipiras

          beneficia ainda mais o solo, pois as aves ajudam a fertilizá-lo naturalmente, participando de
          práticas de agricultura regenerativa que não exigem o uso de fertilizantes artificiais. Já as
          criações livres de gaiolas também reduzem a concentração de dejetos e poluição do solo e
          da água, além de consumir menos energia, pois dispensam grandes galpões mecanizados.
        </p>

        <p>&nbsp;</p>

        <h2>Fazendo a Diferença no Mercado de Ovos</h2>

        <p>
          Escolher entre ovos de galinhas caipiras e livres de gaiolas representa uma adesão a
          práticas que respeitam o bem-estar animal, a saúde humana e o meio ambiente.
        </p>

        <p>
          A <strong>Fazendinha em Casa</strong> promove a <a target='_blank' href="https://www.fazendinha.me/produtos?search=ovos&amp;zipcode=" title="outros produtos">conexão direta entre produtores de agricultura familiar e
          compradores, sejam eles consumidores finais, profissionais da gastronomia ou comércios
          em geral</a>, facilitando o acesso a ovos de qualidade que refletem essas práticas
          sustentáveis. Seja qual for sua escolha, ambos os tipos de ovos oferecem benefícios à
          saúde e são passos importantes para apoiar um sistema alimentar mais ético e sustentável.
        </p>

        <p>
          Para ficar por dentro de mais dicas e novidades sobre a Fazendinha? Nos siga no <br/><a href="https://www.instagram.com/fazendinhaemcasa/" title="Visite o nosso instagram">instagram</a>
          &nbsp;e junte-se a nós nessa jornada de um futuro mais consciente e inovador!
        </p>
      </article>
    ),
  },
  {
    id: 6,
    slug: 'kefir-um-superalimento-e-uma-dieta-rica',
    categories: [{ slug: 'consumo-consciente', name: 'Consumo Consciente' }],
    createdAt: '05 de setembro de 2024',
    title: 'Kefir: Um superalimento e uma dieta rica',
    description:
      'você sabe como incorporar o kefir de leite nas suas refeições diárias ou quais são os verdadeiros benefícios que ele pode trazer para o seu bem-estar?',
    image: {
      url: '/assets/images/blog/kefir-um-superalimento-e-uma-dieta-rica.webp',
    },
    content: (
      <article>
        <p>
          Que tal introduzir um superalimento na sua dieta que além de delicioso é incrivelmente benéfico para a saúde?
          O kefir, um ingrediente milenar que ganhou notoriedade por suas notáveis propriedades probióticas, pode ser o
          que faltava em sua alimentação diária. Originário das montanhas do Cáucaso, este fermentado natural vem
          conquistando espaço na mesa dos brasileiros que buscam opções mais naturais e saudáveis.
        </p>

        <p>
          A crescente demanda por produtos frescos, sem agrotóxicos e sustentáveis encontra no kefir de leite uma
          resposta eficaz e deliciosa. Rico em bactérias benéficas, ele é capaz de melhorar significativamente a flora
          intestinal e fortalecer o sistema imunológico. Mas você sabe como incorporar o kefir nas suas refeições
          diárias ou quais são os verdadeiros benefícios que ele pode trazer para o seu bem-estar?
        </p>

        <p>
          Explorar os benefícios do kefir não apenas promove uma vida mais saudável como também apoia a economia local
          quando escolhido de produtores artesanais. Mas como exatamente isso impacta na sua saúde e no meio ambiente? E
          como essa escolha pode influenciar positivamente no desenvolvimento sustentável da sua região?
        </p>

        <p>&nbsp;</p>

        <h2>Kefir de leite: Entenda a Origem e o Processo de Produção deste Superalimento</h2>

        <p>
          O kefir de leite, conhecido por suas notáveis propriedades probióticas, tem suas raízes profundas nas
          montanhas do Cáucaso. Há séculos, essa pequena comunidade de alta latitude descobriu o poder deste
          superalimento quase por acaso. A origem do kefir remonta a um feliz acidente de natureza e necessidade, quando
          os moradores guardavam leite em bolsas de couro, propiciando assim a fermentação natural. Esse processo
          ancestral não só preservava o leite como também o enriquecia com microorganismos benéficos.
        </p>

        <p>
          A produção de kefir começa com os grãos de kefir, que são uma combinação simbiótica de bactérias e leveduras.
          Estes grãos, quando adicionados ao leite, fermentam por cerca de 24 horas em temperatura ambiente. Durante
          esse tempo, a cultura de kefir transforma o leite em uma bebida espessa e ácida carregada de diversos tipos de
          microorganismos probióticos. Este processo realça notavelmente o perfil nutricional do leite, aumentando seu
          conteúdo de vitaminas B e K, cálcio e proteínas.
        </p>

        <p>
          A natureza artesanal e a qualidade do kefir dependem significativamente da origem do leite e da manutenção das
          culturas de kefir. Este cuidado no processo de produção não só preserva as características originais do kefir
          mas também assegura que o produto final seja de excepcional qualidade e com propriedades probióticas intactas.
          Embora simples, o processo de produção do kefir exige conhecimento e habilidade para manter a cultura de kefir
          saudável e ativa.
        </p>

        <p>&nbsp;</p>

        <h2>Explorando os Benefícios do Kefir para a Saúde e Bem-estar</h2>

        <p>
          O kefir, um alimento fermentado que vem conquistando cada vez mais adeptos devido às suas propriedades
          probióticas, é uma verdadeira fonte de saúde. Rico em bactérias benéficas e leveduras, este superalimento
          contribui significativamente para a melhoria da flora intestinal. O equilíbrio da flora intestinal é
          fundamental para a digestão adequada e para a absorção eficiente de nutrientes, além de desempenhar um papel
          crucial na prevenção de doenças intestinais e na melhora geral do sistema digestivo.
        </p>

        <p>
          Além de favorecer a saúde digestiva, o kefir é reconhecido por fortalecer o sistema imunológico. A presença de
          componentes bioativos, como peptídeos e exopolissacarídeos, proporciona ao corpo um escudo contra infecções.
          Estudos sugerem que o consumo regular de kefir pode ajudar a combater infecções, reduzir a inflamação e até
          mesmo melhorar a resposta do corpo ante doenças autoimunes, oferecendo um suporte natural e poderoso para
          manter a saúde e o bem-estar.
        </p>

        <p>
          Para aqueles que buscam uma solução natural para o controle do colesterol, o kefir surge como um aliado
          valioso. Sua composição única pode ajudar na redução dos níveis de colesterol LDL, conhecido como "colesterol
          ruim", e no aumento do HDL, o "colesterol bom". Essa capacidade deve-se à ação das bactérias probióticas que
          modulam o metabolismo lipídico, auxiliando na prevenção de doenças cardiovasculares e promovendo uma vida mais
          saudável.
        </p>

        <p>
          O impacto do kefir vai além da saúde física, influenciando também o bem-estar mental. Estudos apontam que o
          equilíbrio da microbiota intestinal pode estar relacionado à saúde mental, influenciando aspectos como o humor
          e a capacidade de lidar com o estresse. O consumo de kefir, ao promover a saúde intestinal, pode também
          contribuir para a melhoria do humor e para um equilíbrio emocional, consolidando-se como um complemento eficaz
          na dieta de quem busca não apenas a saúde física, mas também mental.
        </p>

        <p>&nbsp;</p>

        <h2>Como Incorporar o Kefir na Sua Culinária: Dicas e Receitas Práticas</h2>

        <p>
          Introduzir o kefir na cozinha do dia a dia pode ser uma jornada deliciosa e incrivelmente saudável. Este
          produto fermentado, conhecido por seus probióticos benéficos, transforma receitas simples em pratos cheios de
          sabor e valor nutricional. Para começar, o kefir de leite pode ser um excelente substituto para ingredientes
          como creme de leite, iogurte ou até mesmo leite em diversas receitas, desde molhos até smoothies. Além disso,
          sua textura cremosa e sabor levemente ácido adicionam um toque especial a cada preparo.
        </p>

        <p>
          Imagine preparar uma manhã começando com um smoothie energético: basta adicionar uma xícara de kefir de leite,
          suas frutas favoritas, uma colher de chia e um toque de mel. Esta bebida não só será refrescante como também
          ajudará a fortalecer seu sistema imunológico. Outra ideia prática e rápida é utilizá-lo em molhos para
          saladas. Misture kefir de leite com ervas frescas picadas, um pouco de azeite, sal e pimenta, e você terá um
          molho delicioso e saudável em minutos.
        </p>

        <p>
          Para os amantes de pratos mais elaborados, o kefir pode ser um ingrediente secreto em suas receitas de
          assados. Substituir parte do leite tradicional por kefir em receitas de pão, bolo ou panquecas não apenas
          incorpora probióticos no seu prato mas também confere uma leveza e umidade especiais que são difíceis de
          alcançar com outros ingredientes. Por exemplo, ao fazer panquecas, substitua metade da quantidade de leite
          indicada na receita por kefir de leite e observe a textura ser transformada, tornando-as mais leves e fofas.
        </p>

        <p>&nbsp;</p>

        <h2>A Escolha Sustentável: Opte por Kefir de Produtores Locais e Artesanais</h2>

        <p>
          Ao escolher kefir de produtores locais e artesanais, você não apenas adquire um produto de alta qualidade, mas
          também contribui para a sustentabilidade ambiental e fortalece a economia da sua comunidade. Os produtores
          locais tendem a usar práticas agrícolas mais sustentáveis que preservam o solo e os recursos hídricos,
          minimizando o impacto no meio ambiente. Além disso, ao diminuir a necessidade de longas distâncias de
          transporte, reduz-se significativamente a emissão de gases poluentes.
        </p>

        <p>
          Optar por kefir de fontes locais e artesanais também garante que você esteja consumindo um produto fresco e
          repleto de benefícios. Os produtores artesanais frequentemente utilizam métodos tradicionais de fermentação
          que podem maximizar as propriedades probióticas do kefir. Essas práticas não apenas mantêm, mas muitas vezes
          melhoram a qualidade nutricional do produto, oferecendo um alimento rico em nutrientes essenciais e benéficos
          à saúde intestinal e ao sistema imunológico.
        </p>

        <p>
          Além dos benefícios ambientais e de saúde, comprar kefir de produtores locais e artesanais ajuda a manter viva
          a cultura alimentar da região. Cada produtor traz um toque único ao seu kefir, refletindo as tradições e o
          terroir local. Isso significa que ao consumir esses produtos, você tem uma experiência gastronômica única e
          profundamente conectada às raízes culturais da comunidade. É uma forma de viajar através dos sabores sem sair
          de casa.
        </p>

        <p>
          Finalmente, escolher kefir de produtores locais e artesanais <a href="https://www.fazendinha.me/produtos/derivados-de-kefir" title="como os da Fazendinha">como os da Fazendinha</a> não só assegura a qualidade
          e frescor, mas também promove um relacionamento mais próximo e confiável entre consumidor e produtor. Isso
          fortalece o tecido social e econômico das comunidades locais, criando uma rede de suporte mútuo que beneficia
          todos os envolvidos. Ao fazer essa escolha, você participa de uma cadeia de consumo consciente e impacta
          positivamente o mundo à sua volta.
        </p>

        <p>&nbsp;</p>
        <p>
          Compreender a origem e a qualidade do que consumimos nunca foi tão importante. Na Fazendinha, nosso
          compromisso é com a autenticidade e com o sabor de verdade.
        </p>

        <p>
          Ao adquirir seu kefir de leite através dos nossos produtores parceiros, você experimenta a conveniência de
          receber produtos diretamente de produtores locais sem sair de casa. Oferecemos uma plataforma fácil de navegar
          que não só simplifica o processo de compra como também oferece diversas opções de entrega. Assim,
          independentemente de onde você esteja, garantimos que o frescor e a qualidade do kefir de leite artesanal
          cheguem intactos até você, prontos para serem incorporados à sua dieta de maneira simples e prática.
        </p>
        <p>&nbsp;</p>
        <img
          src="/assets/images/blog/mesa-com-toalha-de-renda-com-frutas-vermelhas-e-kefir.webp"
          alt="Mesa com toalha de renda com frutas vermelhas e kefir"
        />

        <h2>Logo...</h2>

        <p>
          Ao explorar os vastos benefícios do kefir de leite e as diversas maneiras de incluí-lo em sua dieta,
          ressaltamos não apenas a importância deste superalimento para a saúde, mas também o valor de optar por
          produtos locais e artesanais como os disponibilizados por aqui! Esse compromisso com a qualidade e a
          sustentabilidade reflete a essência de uma alimentação consciente e responsável, alinhada às suas necessidades
          de consumo de produtos frescos e naturais.
        </p>

        <p>
          Aqui na Fazendinha, você tem o privilégio de escolher kefir de leite, <a href="https://www.fazendinha.me/produto/mr-kefir-probioticos-kefir-de-leite-e-de-leite-de-coco-500ml-mr-kefir" title="leite de coco">leite de coco</a>, de leite de cabra, de
          água ou até mesmo o Cream Cheese de Kefir e <a href="https://www.fazendinha.me/produtos" title="outros produtos">outros produtos</a> diretamente de pequenos produtores que cultivam
          com respeito ao meio ambiente e com uma paixão pela tradição local. Ao fazer essa escolha, você não só
          beneficia sua saúde com alimentos frescos e sem agrotóxicos, mas também contribui para fortalecer a economia
          local e promover práticas de agricultura mais sustentáveis.
        </p>

        <p>
          Convidamos você a explorar nosso site, descobrir a variedade de produtos que oferecemos e começar a fazer
          escolhas alimentares que transformarão sua saúde e bem-estar. Aproveite a conveniência de receber tudo
          fresquinho em sua casa e junte-se a nós nessa jornada de apoio à cultura e sustentabilidade local. Visite no
           &nbsp;<a href="https://www.instagram.com/fazendinhaemcasa/" title="Visite o nosso instagram">instagram</a> e faça seu pedido hoje mesmo pelo site ou pelo App Fazendinha Fácil!
        </p>
      </article>
    ),
  },
  {
    id: 5,
    slug: 'por-que-escolher-produtos-organicos-e-sustentavel',
    categories: [{ slug: 'consumo-consciente', name: 'Consumo Consciente' }],
    createdAt: '05 de setembro de 2024',
    title: 'Por que escolher produtos organicos é sustentável',
    description:
      'Convidamos você a explorar nosso catálogo e descobrir como é fácil e gratificante fazer parte desta mudança. Seja escolhendo produtos que apoiam a sustentabilidade, seja apoiando os pequenos produtores locais, sua decisão faz a diferença.',
    image: {
      url: '/assets/images/blog/por-que-escolher-produtos-organicos-e-sustentavel.webp',
    },
    content: (
      <article>
        <p>
          Você já parou para pensar sobre como suas escolhas alimentares podem impactar o planeta e a sua saúde? No
          contexto atual, onde a conscientização sobre o meio ambiente se faz cada vez mais presente, falar sobre
          sustentabilidade não é mais uma opção, mas uma necessidade. Neste sentido, escolher produtos orgânicos e
          artesanais emerge como uma ação positiva tanto para nós quanto para o mundo ao nosso redor.
        </p>

        <p>
          A sustentabilidade em nossa alimentação vai além do consumo de produtos frescos; ela abrange o apoio a
          pequenos produtores locais e o emprego de práticas que respeitam o meio ambiente e valorizam o trabalho
          humano. Isso implica um consumo mais consciente e responsável, que favorece a saúde do consumidor e, ao mesmo
          tempo, promove um impacto ambiental menor.
        </p>

        <p>
          Por que, então, escolher produtos orgânicos e artesanais pode ser tão benéfico? Além de serem livres de
          agrotóxicos e substâncias prejudiciais, esses produtos garantem a preservação de técnicas artesanais e
          contribuem significativamente para a economia local. Mas como acessar esses produtos de maneira prática e
          eficiente? Continuar lendo pode te mostrar como isso é possível de forma acessível e conveniente.
        </p>

        <p>&nbsp;</p>
        <p>
          <strong>Sustentabilidade e Sua Importância na Alimentação Atual</strong>
        </p>

        <p>
          Nos últimos anos, a sustentabilidade emergiu como um dos temas mais discutidos globalmente, principalmente no
          contexto alimentar. Entender a sustentabilidade envolve reconhecer práticas que possam ser mantidas sem
          prejudicar as gerações futuras. Na alimentação, isso se traduz em escolhas que impactam menos o ambiente e que
          promovem a saúde dos consumidores e a justiça social. Esse conceito vai além do consumo de alimentos
          orgânicos, abraçando uma visão holística que inclui desde a produção até a forma como os alimentos são
          distribuídos e consumidos.
        </p>

        <p>
          A importância da sustentabilidade na alimentação é evidenciada pela crescente preocupação com as mudanças
          climáticas e seus impactos sobre os sistemas de produção de alimentos. A adoção de práticas sustentáveis não
          só ajuda a reduzir a emissão de gases de efeito estufa, mas também garante a biodiversidade e a utilização
          responsável dos recursos naturais. Além disso, sistemas alimentares sustentáveis podem resultar em alimentos
          mais nutritivos, uma vez que práticas como a agricultura orgânica tendem a usar menos pesticidas e
          fertilizantes químicos, preservando assim os nutrientes dos alimentos.
        </p>

        <p>
          Ao optar por alimentos produzidos de maneira sustentável, os consumidores contribuem diretamente para a
          economia local. O apoio a pequenos produtores e a agricultura familiar é crucial, pois estes são
          frequentemente mais propensos a usar métodos de cultivo que respeitam o meio ambiente. Isso não apenas fomenta
          a economia local, mas também ajuda na conservação de técnicas tradicionais de produção, fortalecendo a cultura
          alimentar de uma região e assegurando a soberania alimentar.
        </p>

        <p>
          Assim, promover a sustentabilidade na alimentação é também promover um estilo de vida que valoriza o bem-estar
          coletivo e o planeta. Além de ser uma responsabilidade ambiental, é uma questão de saúde pública e justiça
          social. Ao compreender esses aspectos, os consumidores podem fazer escolhas mais conscientes que reverberam
          positivamente em toda a cadeia produtiva, incentivando práticas que garantam o bem-estar do planeta e das
          próximas gerações.
        </p>

        <p>&nbsp;</p>
        <p>
          <strong>Por quê escolher produtos orgânicos impacta positivamente sua saúde e o meio ambiente?</strong>
        </p>

        <p>
          Ao optar por produtos orgânicos e artesanais, não estamos apenas fazendo uma escolha alimentar; estamos
          adotando um estilo de vida que reverbera positivamente em nossa saúde e no meio ambiente. Consumidores que
          escolhem esses produtos tendem a consumir alimentos mais seguros e nutritivos, com níveis elevados de
          vitaminas e minerais, essenciais para o bom funcionamento do corpo humano.
        </p>

        <p>
          Do ponto de vista ambiental, a agricultura orgânica e as práticas artesanais têm um impacto significativamente
          menor no meio ambiente. Elas promovem a biodiversidade, conservam os ciclos de recursos naturais e reduzem a
          poluição dos solos e aquíferos que são importantes fontes de recursos naturais, pois podem ser utilizados pelo
          ser humano como fonte de água para consumo. Além disso, ao evitar produtos químicos, essas práticas não apenas
          preservam, mas também enriquecem a terra, possibilitando que as gerações futuras também possam desfrutar de
          recursos naturais saudáveis e abundantes.
        </p>

        <p>
          Outro aspecto crucial é o apoio aos pequenos produtores. Ao escolher produtos orgânicos e artesanais, estamos
          incentivando a economia local e valorizando o trabalho de agricultores que optam por práticas mais
          sustentáveis. Essa escolha ajuda a manter as comunidades rurais, proporcionando-lhes uma vida digna e
          sustentável. É uma forma de resistência ao modelo de agricultura em larga escala, que muitas vezes prioriza a
          quantidade em detrimento da qualidade e da sustentabilidade.
        </p>

        <p>
          Finalmente, quando adotamos esses hábitos de consumo, também estamos fazendo uma declaração sobre o tipo de
          mundo em que queremos viver. Cada escolha consciente é um passo em direção a um futuro mais sustentável e
          saudável. Por isso, ao considerar o impacto de seus hábitos alimentares, lembre-se de que optar por produtos
          orgânicos e artesanais não beneficia apenas a sua saúde, mas também o planeta. Essa é uma mensagem poderosa de
          cuidado e respeito por nós mesmos e pela Terra.
        </p>

        <p>&nbsp;</p>
        <p>
          <strong>O Poder dos Pequenos Produtores na Preservação da Cultura e Economia Local</strong>
        </p>

        <p>
          Os pequenos produtores desempenham um papel crucial não apenas na economia, mas na própria sustentação das
          práticas culturais e artesanais que formam a identidade de uma comunidade. Através do cultivo de técnicas
          passadas de geração para geração, esses produtores mantêm vivas as tradições que, de outra forma, poderiam ser
          esquecidas. Além disso, ao priorizar métodos de produção mais sustentáveis e respeitosos ao meio ambiente,
          eles fornecem não apenas alimentos, mas uma história, uma experiência ligada à terra e às mãos que a cultivam.
        </p>

        <p>
          No contexto econômico, o impacto dos pequenos produtores é igualmente significativo. Ao apoiá-los,
          incentiva-se a circulação de capital dentro da própria comunidade, fortalecendo a economia local. Isso
          contrasta fortemente com os modelos de grandes corporações, onde frequentemente os lucros são desviados para
          longe das áreas onde realmente ocorre a produção. Comprar diretamente de pequenos agricultores e artesãos
          significa que mais dinheiro permanece na comunidade, melhorando a qualidade de vida de todos os envolvidos.
        </p>

        <p>
          Outro aspecto importante é como essa prática de consumo consciente e apoio local pode alterar o panorama de
          desenvolvimento regional. Promover os pequenos produtores é também uma forma de fomentar o empreendedorismo
          local, gerando não só empregos, mas também um sentimento de pertencimento e de orgulho pela produção “da
          casa”. Este esquema de apoio mútuo cria uma rede de segurança econômica e emocional, onde produtores e
          consumidores são parceiros em um ciclo virtuoso de crescimento e sustentabilidade.
        </p>

        <p>&nbsp;</p>
        <p>
          <strong>Acesso a Produtos Sustentáveis Com Entrega Rápida e Acessível</strong>
        </p>

        <p>
          Em um mundo cada vez mais consciente sobre as questões ambientais, o acesso a produtos sustentáveis tornou-se
          não apenas uma necessidade, mas uma urgência. Aqui na Fazendinha, nós entendemos essa demanda e a importância
          de atendê-la de forma eficaz.
        </p>

        <p>Por isso, desenvolvemos um sistema de entregas que não só garante a rapidez, mas também a acessibilidade.</p>

        <p>
          Isso significa que você pode receber produtos frescos, orgânicos e artesanais diretamente na sua casa ou seu
          negócio, sem ter que se preocupar com o impacto ambiental negativo que longas distâncias de entrega costumam
          causar.
        </p>

        <p>
          Isso é possível graças à nossa{' '}
          <a href="https://www.fazendinha.me/produtores" title="rede de pequenos produtores locais">
            rede de pequenos produtores locais
          </a>
          , que cultivam seus produtos de forma sustentável e são verdadeiros parceiros nessa jornada por um consumo
          mais consciente e responsável.
        </p>

        <p>
          Oferecemos também tarifas de frete únicas e acessíveis, tornando o acesso a produtos orgânicos e artesanais
          viável para um maior número de pessoas. Esse é um dos pilares da nossa missão: democratizar o consumo de
          produtos sustentáveis e, ao mesmo tempo, apoiar a economia local. Comprando na{' '}
          <a href="https://www.fazendinha.me" title="Fazendinha">
            Fazendinha
          </a>
          , você não só garante o melhor para a sua saúde como também contribui para a sustentabilidade de pequenos
          produtores que dependem dessa rede de consumo consciente para continuar suas atividades.
        </p>

        <p>
          Convidamos você a explorar{' '}
          <a href="https://www.fazendinha.me/produtos" title="nosso catálogo de produtos">
            nosso catálogo de produtos
          </a>{' '}
          e descobrir como é fácil e gratificante fazer parte desta mudança. Seja escolhendo produtos que apoiam a
          sustentabilidade, seja apoiando os pequenos produtores locais, sua decisão faz a diferença. Juntos, podemos
          transformar nossos hábitos e nosso planeta.
        </p>
      </article>
    ),
  },
  {
    id: 4,
    slug: 'como-funcionam-as-entregas-na-fazendinha-em-casa',
    categories: [{ slug: 'informacoes', name: 'informações' }],
    createdAt: '25 de maio de 2021',
    title: 'Como funcionam as entregas na Fazendinha em Casa?',
    description:
      'A Fazendinha em Casa é um mercado online de pequenos produtores de alimentos artesanais, locais e agroecológicos...',
    image: {
      url: '/assets/images/blog/como-funciona-as-entregas.jpg.webp',
    },
    content: (
      <article>
        <p>
          A Fazendinha em Casa é um mercado online de produtores locais que produzem de modo artesanal e/ou sustentável.
          Não compramos e revendemos, cada produtor tem sua própria loja no site da Fazendinha, o que possibilita preços
          mais justos para o produtor e para o cliente. O cliente pode navegar livremente e comprar qualquer item,
          pagando todos ao mesmo tempo no fechamento final do carrinho.
        </p>

        <p>&nbsp;</p>
        <p>
          <strong>O que entrega na minha localidade? </strong>
        </p>
        <p>
          Para verificar quais produtores atendem a sua localidade, coloque o CEP desejado no campo que está na parte
          superior do site. Todos os produtos disponíveis você poderá conferir em{' '}
          <a href="https://www.fazendinha.me/produtos" target="_blank" rel="noreferrer">
            www.fazendinha.me/produtos
          </a>
          .
        </p>

        <p>&nbsp;</p>
        <p>
          <strong>Em quais cidades tem produtores entregando pela Fazendinha em Casa?</strong>
        </p>
        <p>
          Estamos crescendo todos os dias, confira sempre com o CEP &lt;3 na página inicial do site, os produtos na sua
          localidade.
        </p>

        <p>
          <strong>MG</strong> - Belo Horizonte, Betim, Contagem, Ibirité, Lagoa Santa, Nova Lima, Santa Luzia,
          Vespasiano, Oliveira <br />
          <strong>DF</strong> – Distrito Federal completo
          <br />
          <strong>BA</strong> – Salvador e Lauro de Freitas <br />
          <strong>PB</strong> – Recife e Olinda <br />
          <strong>CE</strong> – Fortaleza
          <br />
          <strong>PR</strong> – Curitiba, São José dos Pinhais
          <br />
          <strong>RJ</strong> – Capital
          <br />
          <strong>SP</strong> – Capital
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>Dias de entrega</strong>
        </p>
        <p>Há produtores que entregam em um único dia e aqueles que entregam em mais dias.</p>
        <p>Na página de cada produto você tem a informação do dia de entrega dele.</p>
        <p>
          No fechamento do carrinho a Fazendinha mostrará a você o menor número de entregas possível. Alguns produtores
          aparecerão em separado por terem logística separada.
        </p>
        <p>Ao finalizar o pagamento você receberá um e-mail com a confirmação dos dias de entrega.</p>

        <p>&nbsp;</p>
        <p>
          <strong>Cálculo do frete</strong>
        </p>
        <p>É calculado por dia de entrega – Exceto produtores com logística separada.</p>
        <p>&nbsp;</p>
        <p>
          <strong>Horário de entrega</strong>
        </p>
        <p>As entregas acontecem entre 11h e 15h (aproximadamente).</p>
        <hr />
        <br />
        <p>Em caso de dúvidas mande sua mensagem na página de contato do site ou pelo whatsapp.</p>
        <p>
          As entregas são feitas pela FazendinhaLOG, serviço de logística da Fazendinha em Casa, no endereço que você
          pediu.
        </p>
        <p>
          <strong>Economia e comodidade para você!</strong>
        </p>
      </article>
    ),
  },

  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  {
    id: 1,
    slug: 'expressar-gourmet-ganha-premio-na-inglaterra-como-uma-das-melhores-geleias-do-mundo',
    categories: [{ slug: 'curiosidades', name: 'curiosidades' }],
    createdAt: '07 de julho de 2021',
    title: 'Expressar Gourmet ganha prêmio na Inglaterra como uma das melhores geleias do mundo',
    description:
      'A tradição da produção local, um dos traços mais fortes da cultura presente nos caminhos da Estrada Real, ganha uma grande aliada na...',
    image: {
      url: '/assets/images/blog/geleia.jpg',
    },
    content: (
      <article>
        <p>
          O que começou como uma conversa, talvez quase despretensiosa, em 2018, se transformou agora, em 2021, em uma
          das melhores geleias do mundo. A Expressar Gourmet, criada pelo casal Bruno e Alynne, teve sua geleia de
          laranja suave com especiarias reconhecida internacionalmente pelo Marmalade Awards, da Inglaterra, que
          acontece anualmente e avalia produtos de vários países do globo e é referência na área. A geleia foi
          recomendada pela premiação na categoria de produtos artesanais, na primeira vez que um produto mineiro recebe
          tal avaliação.
        </p>
        <p>
          A história da Expressar Gourmet inicia como quase toda história de produtos locais. Algo que era feito para
          consumo próprio, mas recheado de memórias afetivas, receitas de família, passadas por gerações, e que abriram
          portas para as primeiras vendas. No começo, fornecendo para restaurantes de amigos, depois expandindo para o
          público em geral e rapidamente ganhando o gosto de quem consome. Hoje os planos são de expansão, impulsionados
          pelo mais novo reconhecimento.
        </p>

        <p>
          Produto local, a geleia de laranja suave com especiarias é uma receita com origens portuguesas, mas casa
          especialmente bem com um típico queijo minas bem curado. Junta a qualidade típica da produção regional com o
          cuidado comum à fabricação artesanal, e agora consta entre as melhores geleias do mundo.
        </p>
        <p>
          Com destaque inclusive na{' '}
          <a href="https://www.em.com.br/app/noticia/economia/2021/07/06/internas_economia,1284011/geleia-mineira-e-destaque-em-premio-mundial-na-inglaterra.shtml">
            imprensa
          </a>
          , a Expressar Gourmet está agora mesmo com sua{' '}
          <a href="https://fazendinha.me/produtores/expressar-gourmet/">loja aberta na Fazendinha em Casa</a>, onde você
          encontra a geleia de laranja suave com especiarias e vários outros produtos, entregues diretamente a você
          junto a toda a variedade de produtos locais, orgânicos e agroecológico dos demais produtores que você só
          encontra por aqui. Já fez suas compras?
        </p>
      </article>
    ),
  },

  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  {
    id: 2,
    slug: 'fazendinha-em-casa-e-estrada-real-pelos-sabores-e-saberes-da-maior-rota-turistica-do-pais',
    categories: [{ slug: 'informacoes', name: 'informações' }],
    createdAt: '05 de julho de 2021',
    title: 'Fazendinha em Casa e Estrada Real: Pelos sabores e saberes da maior rota turística do país',
    description:
      'A tradição da produção local, um dos traços mais fortes da cultura presente nos caminhos da Estrada Real, ganha uma grande aliada na...',
    image: {
      url: '/assets/images/blog/estrada-real.webp',
    },
    content: (
      <article>
        <p>
          A tradição da produção local, um dos traços mais fortes da cultura presente nos caminhos da Estrada Real,
          ganha uma grande aliada na distribuição de seus sabores e saberes. A Fazendinha em Casa, um mercado online
          para venda de produtos locais, artesanais, orgânicos e agroecológicos, e o{' '}
          <a href="http://www.institutoestradareal.com.br/">Instituto Estrada Real</a>, responsável pela principal rota
          histórica e turística do Brasil, se unem em uma parceria que fortalece os valores dos produtores da região e a
          memória afetiva inerente aos produtos oferecidos ao longo do trajeto para levar toda essa produção aos quatro
          cantos do Brasil.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>A Parceria</strong>
        </p>
        <p>
          A parceria entre a Fazendinha em Casa e o Instituto Estrada Real tem como objetivo fortalecer a cadeia de
          produção local da rota turística, permitindo uma venda simples e direta através da plataforma, aliada a uma
          logística que leve os produtos da Estrada Real a compradores de todo o Brasil. Ela conta com o apoio das
          administrações municipais de cada localidade para divulgação e apoio institucional local.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>Sabores e Sabores da Estrada Real</strong>
        </p>
        <p>
          Desde o mês de junho de 2021 já se encontra ativa a página{' '}
          <a href="http://www.fazendinha.me/cadastramentoER">www.fazendinha.me/cadastramentoER</a>, para o pré-cadastro
          dos produtores localizados nas mais de 200 cidades da Estrada Real para que estes possam vir a oferecer seus
          produtos nacionalmente por meio da Fazendinha em Casa. Os produtores devem fornecer informações básicas sobre
          o trabalho realizado e os produtos oferecidos, para então receber um contato da plataforma de vendas online
          com informações sobre o funcionamento da parceria e sobre como abrir sua loja virtual e distribuir seus
          produtos nacionalmente. Os produtores que aderirem à parceria terão condições especiais em taxas e no uso da
          plataforma para ampliar as possibilidades de comercialização, além de receber o selo oficial da Estrada Real
          na sua loja na Fazendinha.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>Loja de licenciados Estrada Real</strong>
        </p>
        <p>
          Além da produção local, será possível também adquirir produtos licenciados da Estrada Real diretamente da
          plataforma, que contará com uma loja oficial da Estrada Real com toda a linha de souvenires, linha de
          decoração e demais itens oficiais, que estarão disponíveis para venda por atacado ou varejo.
          <br />
          Em breve: <a href="http://www.fazendinha.me/IER">www.fazendinha.me/IER</a>
        </p>
        <p>
          <strong>A Fazendinha em Casa</strong>
        </p>
        <p>
          Uma rede online de pequenos produtores, levando do campo à mesa produtos artesanais, locais e agroecológicos a
          todo o Brasil. Acreditando que um mundo mais sustentável só é possível fortalecendo as pessoas e seus
          territórios, a Fazendinha em Casa traz os valores da terra para dentro do seu dia a dia. Nascida de uma
          cultura do artesanal, do local, do sustentável e de conceitos do Slow Food, ela possibilita a conexão direta
          entre pequenos produtores e quem busca alimentos e produtos saudáveis, em uma experiência simples e prática,
          através da tecnologia de vendas online e distribuição logística. Assim, fortalece toda uma cadeia de produção
          e promove um ecossistema vivo voltado ao bem-estar das pessoas envolvidas: produtores, clientes e motoristas.
        </p>
        <p>
          Por meio da Fazendinha em Casa, pequenos produtores acessam clientes de todo o Brasil. Eles possuem sua
          própria loja online na plataforma, onde conduzem livremente a disponibilidade de seus produtos, experiências e
          realizam toda a gestão de estoque e preços. Através das soluções de logística, o produtor ainda tem a
          facilidade na distribuição, podendo focar na sua produção. Ao comprar na Fazendinha em Casa, você encontra a
          maior diversidade de produtos artesanais, locais e agroecológicos, com a simplicidade de se comprar online, e
          receber seus produtos onde lhe for conveniente.
        </p>
        <p>
          São mais de 100 produtores cadastrados na plataforma, que obteve em 2020 um crescimento de quase 1.000%,
          acompanhando uma forte demanda do setor, impulsionado pelo contexto global que fortaleceu a busca por uma
          alimentação saudável.
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>
            <a href="http://www.institutoestradareal.com.br/">O Instituto Estrada Real</a>
          </strong>
          <br />
          O Instituto Estrada Real é uma instituição da sociedade civil, sem fins lucrativos, criada pela Federação das
          Indústrias do Estado de Minas Gerais (FIEMG) com a finalidade de valorizar o patrimônio histórico-cultural,
          estimular o turismo, a preservação e revitalização dos entornos das antigas Estradas Reais remanescentes.
          <br />A Estrada Real é a maior rota turística do Brasil, redescobrindo os caminhos da Coroa Portuguesa para o
          trânsito de ouro e diamantes de Minas Gerais até os portos do Rio de Janeiro. As trilhas que foram delegadas
          pela realeza ganharam o nome de Estrada Real. São mais de 1.630 quilômetros de extensão e 300 anos de
          história, contada pelos produtores locais e pelas paisagens únicas do percurso.
        </p>
      </article>
    ),
  },

  {
    id: 3,
    slug: 'o-que-afinal-e-agroecologia-e-por-que-eu-deveria-pensar-nisso',
    categories: [{ slug: 'blog', name: 'blog' }],
    createdAt: '05 de junho de 2021',
    title: 'O que, afinal, é agroecologia e por que eu deveria pensar nisso?',
    description:
      'Muitas vezes, ao acompanhar nossos conteúdos, entrevistas, ou mesmo as falas dos nossos produtores parceiros, é comum nos depararmos com...',
    image: {
      url: '/assets/images/blog/fazenda-mangalo-joao-marcelo.jpg.webp',
    },
    content: (
      <article>
        <p>
          Muitas vezes, ao acompanhar nossos conteúdos, entrevistas, ou mesmo as falas dos nossos produtores parceiros,
          é comum nos depararmos com alguns termos que nem sempre fazem parte do dia a dia de todos. A agroecologia
          talvez seja um deles, e é, aqui na Fazendinha, um dos mais importantes pra gente.
        </p>
        <p>
          <strong>Mas o que é, afinal, agroecologia?</strong>
        </p>
        <p>
          A agroecologia é um conjunto de técnicas e conceitos que junta a agricultura à ecologia. É uma forma de pensar
          a produção de alimentos da forma mais sustentável possível, indo além do fato de não se usar agrotóxicos,
          fertilizantes químicos ou sementes trangênicas. Sustentátel em todos os aspectos: ambiental, econômico e
          social.
        </p>
        <p>
          A agroecologia é a agricultura associada ao desenvolvimento das comunidades locais, é a conexão entre o homem,
          as espécies cultivadas, as espécies animais, os recursos locais, culturais e econômicos que, num sistema de
          produção convencional, como a monocultura, estão desconectados. Portanto, na abordagem agroecológica se busca
          valorizar o território, a dimensão humana, sua gastronomia e cultura local em toda a sua complexidade.
        </p>
        <p>
          Quer comer algo feito com ingredientes sem agrotóxicos, sem impacto destrutivo ao meio ambiente, sem danificar
          o solo onde foi plantado ou até mesmo buscar formas de regenerar um solo por meio da agricultura? Está
          pensando em agroecologia. Mais do que isso, se você valoriza a cultura local, a produção artesanal feita por
          pequenos produtores que usam técnicas sustentáveis e fortalecem a cadeia de produção de alimentos na região
          onde ele atua, está também pensando de forma agroecológica.
        </p>
        <p>
          <strong>E isso é importante?</strong>
        </p>
        <p>
          A agroecologia é fundamental para a revolução que precisamos viver. Você sabia que a quantidade de comida
          produzida hoje, no mundo todo, é mais que suficiente para alimentar toda a população? Ainda assim, temos
          pessoas em vários países sem acesso a esse alimento, e muitos dos que têm acesso, não o recebem com boa
          qualidade. Por isso, o caminho para acabar com a fome e promover uma alimentação saudável passa
          necessariamente por soluções como as propostas pela agroecologia.
        </p>
        <p>
          Por aqui, buscamos valorizar ao máximo os produtores agroecológicos, porque acreditamos que esse é o caminho
          para um mundo sustentável, e usamos da tecnologia para aproximar esses produtores de quem quer promover essa
          mudança no seu dia a dia.
        </p>
        <p>
          Então a dica para quem quer saber mais sobre o assunto é pesquisar bastante (sugerimos uma lida em alguns
          sites como o da{' '}
          <a href="https://www.embrapa.br/agrobiologia/pesquisa-e-desenvolvimento/agroecologia-e-producao-organica">
            Embrapa
          </a>{' '}
          ou do{' '}
          <a href="https://www.greenpeace.org/brasil/blog/5-coisas-que-voce-precisa-saber-sobre-agroecologia/">
            Greenpeace
          </a>
          ), acompanhar grupos que vogam pela alimentação saudável como o{' '}
          <a href="https://slowfoodbrasil.org/movimento/">Movimento Slow Food</a> e, para valorizar a produção local e
          sustentável, conheça nossos <a href="https://fazendinha.me/produtores/">produtores</a> parceiros e receba em
          casa o melhor dos produtos agroecológicos da sua região.
        </p>
        <p>
          Na foto:{' '}
          <a href="https://fazendinha.me/produtores/fazenda-mangalo/">Produtor João Marcelo – Fazenda Mangalô</a>
        </p>
      </article>
    ),
  },

  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  {
    id: 3,
    slug: 'fazendinha-em-casa-no-jornal-minas-do-campo-a-mesa',
    categories: [{ slug: 'curiosidades', name: 'curiosidades' }],
    createdAt: '23 de maio de 2021',
    title: 'Fazendinha em Casa no Jornal Minas e Jornal da Alterosa – Do campo à mesa',
    description:
      'Jornal Minas mostra os caminhos do campo à mesa na Fazendinha em Casa, conectando produtores a compradores por meio de tecnologias de comercialização e logística...',
    image: {
      url: '/assets/images/blog/fazendinha-em-casa-rede-minas.jpg.webp',
    },
    content: (
      <article>
        <p>
          Jornal Minas mostra os caminhos do campo à mesa na Fazendinha em Casa, conectando produtores a compradores por
          meio de tecnologias de comercialização e logística. Confira a reportagem:
        </p>
        <Youtube embedId="fiWQ56l4ugs" />
        <p>
          <strong>Fazendinha em Casa no Jornal da Alterosa (SBT)</strong>
        </p>
        <p>O crescimento dos orgânicos durante a pandemia e a conscientização cada vez maior dos consumidores.</p>
        <Youtube embedId="PMJo8iBWEhg" />
      </article>
    ),
  },

  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  {
    id: 5,
    slug: 'a-moringa-e-as-maes',
    createdAt: '08 de maio de 2021',
    categories: [{ slug: 'curiosidades', name: 'curiosidades' }],
    title: 'A Moringa e as Mães',
    description:
      'Muitos a consideram a Moringa a planta da esperança. Originária de territórios semi-áridos, muito comum na África e no Norte brasileiro...',
    image: {
      url: '/assets/images/blog/moringa-915-x-420.jpg.webp',
    },
    content: (
      <article>
        <p>
          Muitos a consideram a Moringa a planta da esperança. Originária de territórios semi-áridos, muito comum na
          África e no Norte brasileiro, a Moringa é uma daquelas super plantas. Além de suas flores, que dão quase o ano
          todo, ajudam a recuperar o solo, purificar a água, produzem um óleo de excelente qualidade e suas folhas são
          fontes ricas de alimento, além de suas raízes, com propriedades medicinais.
        </p>
        <p>
          Que a Moringa com todo o seu potencial, represente neste Dia das Mães, um pouco do que o calor de mãe costuma
          trazer pra gente: acalento e a segurança de que, mesmo em tempos árduos, tudo vai ficar bem.
        </p>
        <p>
          Saiba mais sobre a moringa e também adquira a sua
          <a href="https://fazendinha.me/produto/muda-de-moringa-fabrica-de-hortas/"> aqui, </a>na{' '}
          <a href="https://fazendinha.me/produtores/fabrica-de-hortas/">loja da Fábrica de Hortas</a>.
        </p>
      </article>
    ),
  },

  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  {
    id: 5,
    slug: 'apoie-o-produtor-local',
    categories: [{ slug: 'blog', name: 'blog' }],
    createdAt: '25 de abril de 2021',
    title: 'Apoie o produtor local',
    description:
      'Aqui na Fazendinha acreditamos que a transformação do mundo à nossa volta passa pela forma como nos alimentamos...',
    image: {
      url: '/assets/images/blog/apoie-o-produtor-local-915-x-420.jpg.webp',
    },
    content: (
      <article>
        <p>
          Aqui na Fazendinha acreditamos que a transformação do mundo à nossa volta passa pela forma como nos
          alimentamos. E essa transformação acontece em cadeia. Uma alimentação saudável, unida a um estilo de vida mais
          equilibrado, provoca a busca por alimentos produzidos de forma sustentável, em um modelo que aquece a economia
          local e reduz distâncias entre o consumidor e o produtor. É o que chamamos por aqui de modelo do-campo-à-mesa,
          que você pode conhecer um pouco mais{' '}
          <a href="https://fazendinha.me/a-cozinha-do-campo-a-mesa/">nesse link.</a>
        </p>
        <p>
          E em tempos de quarentena, o aspecto social e econômico dessa transformação ganha um peso ainda maior. Afinal,
          se você chegou até aqui, já considerou fazer suas compras do dia-a-dia de forma virtual, se já não está
          fazendo, pra evitar sair de casa, certo? E de outro lado, os produtores dependem cada vez mais da proximidade
          com seus compradores para se manter de pé em tempos de crise.
        </p>
        <p>
          Estamos trabalhando diretamente para apoiar essa transformação. A Fazendinha aproxima o produtor do seu
          consumidor, permitindo que você compre diretamente de quem produz, e receba tudo em casa. Além de entregar a
          comodidade do delivery, permitimos que os produtores coloquem sua própria loja online, defina seus próprios
          preços e conte com toda a nossa logística de entrega. Assim, eles podem focar na qualidade dos produtos,
          enquanto a gente garante a chegada dos produtos à sua casa.
        </p>
        <p>
          Quer conhecer quem são <a href="https://fazendinha.me/produtores/">os produtore</a>s que vendem na Fazendinha
          em Casa? Que tal dar uma passeada pelo nosso <a href="https://fazendinha.me/">site</a> e conhecer os produtos
          que estão à venda?
        </p>
        <p>
          Conheça os <a href="https://fazendinha.me/entregas-por-dia-da-semana/">produtos disponíveis</a>, apoie o
          produtor local. São eles que garantirão a transformação que nos aguarda, e cabe a nós garantir que a cadeia
          produtiva siga funcionando.
        </p>
        {/* <p>
          <a href="https://i1.wp.com/fazendinha.me/wp-content/uploads/2021/04/pedro-leone-p.jpg?ssl=1">
            <img
              src="https://i1.wp.com/fazendinha.me/wp-content/uploads/2021/04/pedro-leone-p.jpg?resize=150%2C150&amp;ssl=1"
              alt=""
              width="150"
              height="150"
              srcSet="https://i1.wp.com/fazendinha.me/wp-content/uploads/2021/04/pedro-leone-p.jpg?w=150&amp;ssl=1 150w, https://i1.wp.com/fazendinha.me/wp-content/uploads/2021/04/pedro-leone-p.jpg?resize=62%2C62&amp;ssl=1 62w, https://i1.wp.com/fazendinha.me/wp-content/uploads/2021/04/pedro-leone-p.jpg?resize=60%2C60&amp;ssl=1 60w, https://i1.wp.com/fazendinha.me/wp-content/uploads/2021/04/pedro-leone-p.jpg?resize=80%2C80&amp;ssl=1 80w, https://i1.wp.com/fazendinha.me/wp-content/uploads/2021/04/pedro-leone-p.jpg?resize=100%2C100&amp;ssl=1 100w"
              sizes="(max-width: 150px) 100vw, 150px"
              data-recalc-dims="1"
            />
          </a>
        </p> */}
        <p>
          <em>
            Eu sou o Pedro Leone e a partir de hoje vou contar para você um pouco mais sobre o universo que envolve a
            agricultura, alimentação, sustentabilidade e também muitas histórias que acontecem nos bastidores da
            Fazendinha em Casa.
          </em>
        </p>
      </article>
    ),
  },

  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  {
    id: 6,
    slug: 'qual-a-diferenca-entre-alimentos-produzidos-no-modelo-convencional-organico-e-agroecologico',
    categories: [{ slug: 'curiosidades', name: 'curiosidades' }],
    createdAt: '02 de outubro de 2020',
    title: 'Qual a diferença entre alimentos produzidos no modelo convencional, orgânico e agroecológico?',
    description:
      'O cultivo convencional é o que faz uso de agrotóxicos, fertilizantes sintéticos e pesticidas para a otimização do processo de produção agrícola...',
    image: {
      url: '/assets/images/blog/qual-a-diferenca-entre-alimentos-convencional-organico-e-agroecologico.jpg.webp',
    },
    content: (
      <article>
        <p>
          <strong>CONVENCIONAL</strong>
        </p>
        <p>
          O cultivo convencional é o que faz uso de agrotóxicos, fertilizantes sintéticos e pesticidas para a otimização
          do processo de produção agrícola. Além disso, é usual a prática das monoculturas, em que o agricultor faz o
          plantio de uma única espécie – o que prejudica a recuperação e manutenção do solo. A agricultura convencional,
          por se valer de mecanismos e tecnologias artificiais para a proteção da lavoura, é considerada muito agressiva
          tanto ao meio ambiente quanto à saúde humana.
        </p>
        <p>
          Como consequência, tem-se a degradação do solo, contaminação do solo e corpos hídricos no entorno das
          plantações, contaminação de reservas subterrâneas de água, os chamados lençóis freáticos, desmatamento e
          desequilíbrio do efeito estufa. Em relação à saúde humana, estudos comprovam danos associados à ingestão de
          alimentos contaminados por quantidade excessiva de agrotóxicos, o que pode causar disfunções hormonais,
          contaminação de leite materno, má formação do feto e dificuldades no desenvolvimento das capacidades
          cognitivas, além de serem substâncias possivelmente carcinogênicas.
        </p>
        <p>
          <strong>ORGÂNICO</strong>
        </p>
        <p>
          O termo Agricultura Orgânica apareceu por volta de 1920, quando surgiram movimentos e manifestações contrários
          à adubação química e a favor da prática de culturas baseadas nos processos biológicos naturais. Inicialmente,
          os movimentos foram agrupados em quatro grandes vertentes: a agricultura orgânica, biodinâmica, biológica e
          natural. Em meados de 1970, essas vertentes foram agrupadas e nomeadas como agricultura alternativa, o que nos
          dias atuais é conhecido por Agricultura Orgânica. A forma de plantio na produção orgânica, no que diz respeito
          à agricultura, não faz uso de agrotóxicos, sementes geneticamente modificadas (transgênicos) e fertilizantes
          sintéticos. Em relação à pecuária, o gado deve ser criado sem remédios ou hormônios.
        </p>
        <p>
          <strong>AGROECOLÓGICO</strong>
        </p>
        <p>
          Já a agroecologia, é a junção harmônica de conceitos das ciências naturais com conceitos das ciências sociais.
          Ela tem como princípio chave a diversidade e o fator humano, visando sempre a sustentabilidade ecológica,
          econômica, social, cultural, política e ética. A agroecologia é uma ciência e um movimento social. Suas
          práticas possuem dimensões tecnológicas, sociais, políticas e econômicas. Além de não usar venenos, ela vai
          além: realiza o manejo sustentável, valoriza as sementes tradicionais e cultiva alimentos em harmonia com a
          natureza e a cultura local.
        </p>
      </article>
    ),
  },
]
